export const GUIDED_TOUR_BUTTON_ID = 'guided-tour';

export enum GuidedTourState {
  DISABLED = 'disabled',
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  PENDING = 'pending',
  AUTOSTART = 'autostart',
}
